export const SUCCESS_TYPE = 'SUCCESS' as const;
export const WARNING_TYPE = 'WARNING' as const;
export const ERROR_TYPE = 'ERROR' as const;
export const INFO_TYPE = 'INFO' as const;

export type FlagType =
	| typeof SUCCESS_TYPE
	| typeof WARNING_TYPE
	| typeof ERROR_TYPE
	| typeof INFO_TYPE;
